import { render, staticRenderFns } from "./TaskCalendarView.vue?vue&type=template&id=2894f7e9"
import script from "./TaskCalendarView.vue?vue&type=script&lang=js"
export * from "./TaskCalendarView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports